import React from "react";
import TopPosts from "@radarly/components/widgets/top-posts";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { usePostsWidgetData } from "@radarly/core/widgets/use-cases";
import { DatavizTopPosts } from "@radarly/models/dataviz";
import { SearchFragmentPosts } from "@radarly/models/search";
import Empty from "../../empty";
import Loading from "../../loading";

interface SharedWidgetPostsTopPostsProps {
  project: number;
  fragment: SearchFragmentPosts;
  dataviz: DatavizTopPosts;
  forceReload?: boolean;
  onClick?: () => void;
  isFullscreen?: boolean;
  closeFullscreen?: () => void;
}

export default function SharedWidgetPostsTopPosts({
  project,
  fragment,
  forceReload,
  onClick,
  isFullscreen,
  closeFullscreen,
}: SharedWidgetPostsTopPostsProps) {
  const { loading, posts, total, timezone } = usePostsWidgetData(
    project,
    fragment
  );
  const locale = useCurrentUserLocale();
  const currentProject = useCurrentProject();
  const _onClick = () => {
    if (isFullscreen) {
      closeFullscreen();
    }
    onClick();
  };
  const isEmpty = !loading && posts.length === 0;

  return (
    <Loading loading={loading} forceReload={forceReload}>
      <Empty empty={isEmpty}>
        <TopPosts
          posts={posts}
          total={total}
          project={currentProject}
          timezone={timezone}
          locale={locale}
          onClick={onClick ? _onClick : null}
          isFullscreen={isFullscreen}
          closeFullscreen={closeFullscreen}
        />
      </Empty>
    </Loading>
  );
}
